import { ArrowRightOutlined, MoreOutlined, RightOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { CSSProperties } from "styled-components";
import { BorderLeftBlock, BorderLeftCircle, BorderLine, BorderRightBlock, Content, ContentCardWrapper, Title, TitleBorder, TitleCn, TitleEn, TitleSeparator } from "./ContentCard.styled";

interface ContentCardProps {
    titleCn: string,
    titleEn?: string,
    titleBackgroundHide?: boolean,
    style?: CSSProperties,
    children?: ReactNode[] | ReactNode,
}

let ContentCard: React.FC<ContentCardProps> = (props)=> {

    return <ContentCardWrapper style={props.style}>
        <Title className="hud-card-header">
            <RightOutlined style={{margin: '0px 10px', color: '#4096ff'}} />
            <TitleCn>{props.titleCn}</TitleCn>
            <TitleSeparator> / </TitleSeparator>
            <TitleEn>{props.titleEn}</TitleEn>
            <div style={{flex: '1 1 auto'}} />
            <MoreOutlined style={{fontSize: '16px'}} />
        </Title>

        <Content>
            {props.children}
        </Content>

        <div className="corner-br"></div>
    </ContentCardWrapper>
};

export default ContentCard;

